import Resources from '../../helpers/resources';
import { decodeAuthToken } from '../../helpers/utils';
import msgActions from './message_modal_actions';

export const AUTHENTICATE = 'AUTHENTICATE';

// Actions for message modal
const authenticate = () => async (dispatch) => {
    let authToken;
    // Only validate the authenticity of the authToken if username/password is not provided
    if (!Resources.env.username || !Resources.env.password) {
        authToken = decodeAuthToken(Resources.env.authToken);
        const res = await Resources.verifyAuthToken.get({ authToken }).send();
    
        if (res && res.valid) {
            dispatch({
                type: AUTHENTICATE,
                payload: ''
            })
        } else {
            dispatch(msgActions.openModal({
                contentType: 0,
                heading: res.title,
                content: res.message
            }));
        }
    } else {
        // Usage of the username/password to manually call the authenticate
        const env = Resources.env;
        env.authToken = Resources.env.authenticate(env.username, env.password);
        Resources.env = env;
    }
};

export default {
    authenticate
};
